import React from "react";
import styles from "./LessonLoader.module.css";
import Spinner from "../Spinner/Spinner";
import { t } from "../../lib/i18n";

const LessonLoader = () => {
    return (
        <div className={styles.container}>
            <Spinner label={t("Loading...")}/>
            <div style={{marginTop: 10, fontFamily: "Nunito, sans-serif"}}>{t("Loading lesson...")}</div>
        </div>
    );
}

export default LessonLoader;